import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';

// Internal links (starting with "/") route via React Router; the rest open in a new tab.
function MdLink({ href, children }) {
    if (href && href.startsWith('/')) return <Link to={href}>{children}</Link>;
    return <a href={href} target="_blank" rel="noreferrer">{children}</a>;
}

export default function Markdown({ children }) {
    return (
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: MdLink }}>
            {children || ''}
        </ReactMarkdown>
    );
}
